import { z } from "zod";

// #392: what an account has paid for. Server-managed like roles[]: no client
// PUT sets or clears it, only an out-of-band write (a tooling/migrations
// script today, Play Billing later). Absent = free.
export type Entitlement = "premium";

// Plain strings, read leniently: an entitlement a newer build knows, or a
// malformed value, must not fail the whole profile read.
export const EntitlementsSchema = z
  .array(z.string().min(1).max(40))
  .max(20)
  .optional()
  .catch(undefined);

/** True when the profile carries the premium entitlement. Takes the typed
 *  Profile or a raw profile document (web's useProfileDoc). */
export function isPremium(p: { entitlements?: unknown } | null | undefined): boolean {
  const e = p?.entitlements;
  return Array.isArray(e) && e.includes("premium" satisfies Entitlement);
}
